// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__lqUPL","load8":"Loader_load8__VDxC6"};